module.exports = __webpack_public_path__ + "img/winter_footer.6f670489.png";